import Swiper from 'swiper/dist/js/swiper.min.js';
import MicroModal from 'micromodal';
import initVue from '../util/plan';

export default {
    init() {
        // JavaScript to be fired on the about us page

        initVue();

        new Swiper('.swiper-container', {
            spaceBetween: 10,
            speed: 600,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            keyboard: {
                enabled: true,
            },
            autoplay: {
                delay: 6000,
            },
            on: {
                click: function (event) {
                  document.querySelector('.modal--viewbox .image').style.backgroundImage = event.target.style.backgroundImage;

                  MicroModal.show('modal-viewbox', {
                    awaitCloseAnimation: true,
                    disableScroll: true,
                  });
                },
            },
        });
    },
  };



// WEBPACK FOOTER //
// ./scripts/routes/templateBusinessplan.js